import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useOrderInvoicePrintData } from "../../../shared/hooks/useInvoicesData";

export default function InvoiceDetails({ invoiceName, onClose }) {
    const {
        isLoading,
        data: invoicePDFData,
        refetch: fetchInvoiceDetails,
    } = useOrderInvoicePrintData(invoiceName);

    const [pdfOpen, setPdfOpen] = useState(false);
    const [numPages, setNumPages] = useState(null);

    const handleClose = () => {
        setPdfOpen(false);
        if (onClose) {
            onClose();
        }
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    useEffect(() => {
        if (invoicePDFData) {
            setPdfOpen(true);
        }
    }, [invoicePDFData]);

    const handleDownload = () => {
        window.open(invoicePDFData, "_blank");
    };

    const handlePrint = () => {
        const iframe = document.createElement("iframe");
        iframe.setAttribute("style", "display: none;");
        document.body.appendChild(iframe);
        iframe.onload = function () {
            iframe.contentWindow.print();
        };
        iframe.src = invoicePDFData;
    };

    const PDFViewerComponent = () => {
        return (
            <Document
                file={invoicePDFData}
                onLoadSuccess={onDocumentLoadSuccess}
            >
                {Array.from(new Array(numPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
            </Document>
        );
    };

    // Use the use effect and not the useMemo...
    useEffect(() => {
        if (invoiceName && invoiceName.length > 0) {
            fetchInvoiceDetails(invoiceName);
        }
    }, [invoiceName]);

    return (
        <>
            <Dialog open={pdfOpen} fullWidth>
                <DialogTitle>
                    <Button onClick={handleDownload} color="primary">
                        Download
                    </Button>
                    <Button onClick={handlePrint}>Print</Button>
                    <Button onClick={handleClose}>Close</Button>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>Table details:</DialogContentText>
                    <>
                        <PDFViewerComponent />
                    </>
                </DialogContent>
            </Dialog>
        </>
    );
}
